<div class="d-flex flex-column gap-4" *ngIf="form" [formGroup]="form">
  <h3 class="section-header" i18n>Mailing Address</h3>
  <div class="form-grid">
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="'attention'" i18n>To the Attention of</label>
      <app-text-input
        formControlName="attention"
        controlId="attention"
        [error]="formSubmitted && form.controls.attention.invalid" />
      <div class="form-input-hint" i18n>Optional</div>
    </div>
  </div>

  <hr class="m-0" />

  <div class="d-flex align-items-center gap-2">
    <app-checkbox-input formControlName="sameAsHeadOffice" controlId="sameAsHeadOffice" />
    <app-form-option-label labelFor="sameAsHeadOffice" i18n>Same as Head Office Address</app-form-option-label>
  </div>

  <app-international-address-form-grid
    *ngIf="!form.controls.sameAsHeadOffice.value"
    controlIdPrefix="mailingAddress"
    [form]="form.controls.address"
    [formSubmitted]="formSubmitted" />
</div>
